import classcat from "classcat";
import React, { useCallback, useContext, useState } from "react";

import { Tag } from "@touchtech/web-baselayer-ui";

import { TAGS_ANIMATION_DURATION } from "@is/constants";
import { ViewStateContext } from "@is/contexts";
import { SearchTerm } from "@is/types";

import css from "./TagComponent.module.css";

type Props = {
  tag: SearchTerm;
  tagKey: string;
  onRemove: (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    tag: SearchTerm
  ) => void;
  index?: number;
  onClick?: (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    key?: string
  ) => void;
};

const TagComponent = ({ tag, onRemove, onClick, tagKey }: Props) => {
  const { searchTerms } = useContext(ViewStateContext).content;
  const [isFadeOut, setIsFadeOut] = useState(false);

  const handleRemove = useCallback(
    (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
      if (onRemove) {
        // searchTags.length > 1 condition use to prevent animation for tag
        searchTerms.length > 1 && setIsFadeOut(true);

        setTimeout(() => {
          onRemove(event, tag);
          searchTerms.length > 1 && setIsFadeOut(false);
        }, TAGS_ANIMATION_DURATION);
      }
    },
    [onRemove, searchTerms.length, tag]
  );

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
      onClick && onClick(event, tagKey);
    },
    [onClick, tagKey]
  );

  return (
    <Tag
      className={classcat([css.tag, { [css.fadeInTag]: !isFadeOut }])}
      dataKey={tag.label ?? tag.value}
      onRemove={handleRemove}
      removable
      onClick={handleClick}
    >
      {tag.label ?? tag.value}
    </Tag>
  );
};

export default TagComponent;
